export const INITIAL_MESSAGE_COUNT: number = 2
